import { useId, useLayoutEffect } from 'react';
import { useDesignWorkspace, type AskPageContext } from './DesignWorkspaceProvider';
import type { WorkspaceModule } from './catalog';

/** Register only the loaded saved resource's identifiers and labels, never its editable payload. */
export const useAskPageContext = (
  value: AskPageContext | null,
  surface: WorkspaceModule | null = null,
) => {
  const owner = useId();
  const { reportContext } = useDesignWorkspace();
  const key = JSON.stringify(
    value && {
      page: value.page,
      ...(value.campaign && { campaign: { id: value.campaign.id, title: value.campaign.title } }),
      ...(value.agent && { agent: { id: value.agent.id, name: value.agent.name } }),
      ...(value.job && { job: { id: value.job.id, name: value.job.name } }),
    },
  );
  useLayoutEffect(() => {
    reportContext?.(owner, JSON.parse(key) as AskPageContext | null, surface);
    return () => reportContext?.(owner, null, surface);
  }, [owner, key, surface, reportContext]);
};
